import Nav from "~/components/nav";
import OptimizeLayout from "~/components/layout";
import Notice from "~/components/notice/home";
import { ExperimentProvider } from "~/state-containers/experiment";
import { Footer } from "~/components/footer";
import { useApp } from "~/state-containers/app";
import { useEffect } from "react";
import cx from "clsx";
import { links } from "~/lib/sitemap-links";
import { HeadContent } from "~/components/head";

const SitemapContainer = () => {
  return (
    <div className="bg-black text-white min-h-screen">
      <div className="mx-auto px-4 lg:px-12 py-12">
        <h1 className="mb-8 text-2.5xl leading-8 lg:leading-tight md:mb-16 lg:text-5xl heading">
          Sitemap
        </h1>
        <div className="flex flex-col md:flex-row">
          {links.map(({ title, items }) => {
            return (
              <div className="mb-12 w-full md:w-1/3" key={title}>
                <h2 className="mb-4 text-xl leading-8 text-white lg:leading-tight md:mb-8 lg:text-2xl heading">
                  {title}
                </h2>
                <ul className="space-y-4 flex flex-col flex-wrap">
                  {items.map(({ title, href, pending }, i) => {
                    return (
                      <li key={i}>
                        <a
                          href={href}
                          rel="noreferrer"
                          target={pending ? "" : "_blank"}
                        >
                          <span
                            className={cx("text-lg hover:opacity-90", {
                              underline: !pending,
                              "opacity-80": pending,
                            })}
                          >
                            {title}
                          </span>
                          {pending ? (
                            <span className="text-xs px-1 font-medium rounded-full bg-volt text-black mx-2 -mb-1">
                              Coming soon
                            </span>
                          ) : null}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default function Sitemap() {
  const { setIsHeroCTAInView } = useApp();
  useEffect(() => {
    setIsHeroCTAInView(false);
  }, []);
  return (
    <>
      <HeadContent />
      <ExperimentProvider>
        <Notice />
        <Nav />
        <SitemapContainer />
        <Footer />
      </ExperimentProvider>
    </>
  );
}

Sitemap.Layout = OptimizeLayout;
